import React, { useState } from 'react';
import BottomSheet from '../common/BottomSheet';
import Button from '../common/Button';
import { CANCEL_REASONS } from '../../utils/constants';
import { formatDayDate, formatTime } from '../../utils/date';

/** Confirm cancellation with a reason. */
export default function CancelSheet({ appointment, onClose, onConfirm, loading }) {
  const [reason, setReason] = useState(CANCEL_REASONS[0]);
  return (
    <BottomSheet
      open={!!appointment}
      onClose={onClose}
      title="Cancel appointment?"
      description={appointment
        ? `${appointment.doctor?.name} · ${formatDayDate(appointment.date)}, ${formatTime(appointment.time)}. This slot will be released to other patients.`
        : ''}
      actions={(
        <>
          <Button variant="primary" block loading={loading} onClick={() => onConfirm(reason)} className="btn--danger-fill">
            Cancel appointment
          </Button>
          <Button variant="outline" block onClick={onClose}>Keep appointment</Button>
        </>
      )}
    >
      <p className="field__label u-mb-2">Reason</p>
      {CANCEL_REASONS.map((r) => (
        <button
          key={r}
          type="button"
          className={`option ${reason === r ? 'option--active' : ''}`}
          onClick={() => setReason(r)}
        >
          <span className="option__dot" />
          {r}
        </button>
      ))}
    </BottomSheet>
  );
}
